import React, { Fragment, useEffect, useState } from "react";
import { differenceInMonths } from "date-fns";
import { shortMonthNameArray } from "../../../utils";
import HotelGroupFilters from "../../HotelGroups/HotelGroupFilters";
import { connect } from "react-redux";
import { isGroupAdmin, isGroupUser, isVenue, isVenueAdmin, token } from "../../../modules/auth";
import { isAgencyAdmin, isCompanyAdmin } from "../../../modules/permissions";
let VenueSnapshotReportTableDash = ({ data = [], dateFilterColumn, isVenueUser }) => {
  const [reportData, setReportData] = useState([]);
  const columnTitleHelper = `Based on ${
    dateFilterColumn === "created_at" ? "date of enquiry" : "event start date"
  }`;

  useEffect(() => {
    if (data && data[0]) {
      setReportData(data[0]);
    }
  }, [data]);

  const dateDifference = (firstDate, secondDate) => {
    return differenceInMonths(secondDate, firstDate);
  };

  const dateRangeHeader = (key, dateRange) => {
    let firstDate = new Date(dateRange[0]);
    let secondDate = new Date(dateRange[1]);
    if (key === "currentMonth") {
      return (
        <>
          <span>
            Current Month
            <br />
            <strong>
              {firstDate.toLocaleString("en-GB", { month: "long" })}
            </strong>
          </span>
        </>
      );
    }
    if (secondDate > new Date()) {
      return (
        <>
          <span>
            This Year
            <br />
            <strong>
              {shortMonthNameArray[firstDate.getMonth()] +
                " " +
                firstDate.getFullYear() +
                " To " +
                shortMonthNameArray[secondDate.getMonth()] +
                " " +
                secondDate.getFullYear()}
            </strong>
          </span>
        </>
      );
    }
    if (secondDate < new Date()) {
      return (
        <>
          <span>
            Last Year
            <br />
            <strong>
              {shortMonthNameArray[firstDate.getMonth()] +
                " " +
                firstDate.getFullYear() +
                " To " +
                shortMonthNameArray[secondDate.getMonth()] +
                " " +
                secondDate.getFullYear()}
            </strong>
          </span>
        </>
      );
    }
    let difference = dateDifference(firstDate, secondDate);
    if (difference > 1 && difference < 12) {
      return (
        shortMonthNameArray[firstDate.getMonth()] +
        " " +
        firstDate.getFullYear() +
        " To " +
        shortMonthNameArray[secondDate.getMonth()] +
        " " +
        secondDate.getFullYear()
      );
    } else if (firstDate && secondDate) {
      return `${
        shortMonthNameArray[firstDate.getMonth()]
      } ${firstDate.getUTCFullYear()} To ${
        shortMonthNameArray[secondDate.getMonth()]
      } ${secondDate.getUTCFullYear()}`;
    }
    return "";
  };

  const formatValue = value => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  return (
    <Fragment>
      <table className={"edge-table-no-stripe"}>
        <thead>
          <tr>
            <td>&nbsp;</td>
            {reportData &&
              reportData.length > 0 &&
              reportData.map((report, index) => {
                if (report.date_range) {
                  return (
                    <td key={index} style={{ textAlign: "right" }}>
                      <span className={"text-sm"}>
                        {dateRangeHeader(report.key, report.date_range)}
                      </span>
                    </td>
                  );
                }
              })}
          </tr>
        </thead>
        <tbody>
          {reportData && reportData.length > 0 && (
            <>
              <tr className={"bg-off-white"}>
                <td>
                  <strong>Enquiries</strong> <span className={"text-xs"}>(Direct % vs Managed %)</span>
                </td>

                <td style={{ textAlign: "right" }}>
                  <span title={"Direct"}>
                    {reportData[0].percentage_of_direct_enquiries}%
                  </span>{" "}
                  /{" "}
                  <span title={"Managed"}>
                    {reportData[0].percentage_of_managed_enquiries}%
                  </span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <span title={"Direct"}>
                    {reportData[1].percentage_of_direct_enquiries}%
                  </span>{" "}
                  /{" "}
                  <span title={"Managed"}>
                    {reportData[1].percentage_of_managed_enquiries}%
                  </span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <span title={"Direct"}>
                    {reportData[2].percentage_of_direct_enquiries}%
                  </span>{" "}
                  /{" "}
                  <span title={"Managed"}>
                    {reportData[2].percentage_of_managed_enquiries}%
                  </span>
                </td>
              </tr>
              <tr>
                <td title={columnTitleHelper}>
                  <span className={"my-1 inline-block"}>No. of Enquiries</span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[0].number_of_enquiries}</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[1].number_of_enquiries}</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[2].number_of_enquiries}</strong>
                </td>
              </tr>

              <tr className={"bg-off-white"}>
                <td>
                  <strong>Confirmed</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <span title={"Direct"}>
                    {reportData[0].percentage_of_direct_confirmed_bookings}%
                  </span>{" "}
                  /{" "}
                  <span title={"Managed"}>
                    {reportData[0].percentage_of_managed_confirmed_bookings}%
                  </span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <span title={"Direct"}>
                    {reportData[1].percentage_of_direct_confirmed_bookings}%
                  </span>{" "}
                  /{" "}
                  <span title={"Managed"}>
                    {reportData[1].percentage_of_managed_confirmed_bookings}%
                  </span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <span title={"Direct"}>
                    {reportData[2].percentage_of_direct_confirmed_bookings}%
                  </span>{" "}
                  /{" "}
                  <span title={"Managed"}>
                    {reportData[2].percentage_of_managed_confirmed_bookings}%
                  </span>
                </td>
              </tr>
              <tr>
                <td title={columnTitleHelper}>
                  <span className={"my-1 inline-block"}>No. of Enquiries</span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[0].number_of_confirmed_bookings}</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[1].number_of_confirmed_bookings}</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[2].number_of_confirmed_bookings}</strong>
                </td>
              </tr>

              <tr>
                <td title={columnTitleHelper}>
                  <span className={"my-1 inline-block"}>
                    Value of Enquiries
                  </span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>
                    {formatValue(reportData[0].value_of_confirmed_bookings)}
                  </strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>
                    {formatValue(reportData[1].value_of_confirmed_bookings)}
                  </strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>
                    {formatValue(reportData[2].value_of_confirmed_bookings)}
                  </strong>
                </td>
              </tr>

              <tr className={"bg-off-white"}>
                <td>
                  <strong>Provisional</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <span title={"Direct"}>
                    {reportData[0].percentage_of_direct_provisional_bookings}%
                  </span>{" "}
                  /{" "}
                  <span title={"Managed"}>
                    {reportData[0].percentage_of_managed_provisional_bookings}%
                  </span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <span title={"Direct"}>
                    {reportData[1].percentage_of_direct_provisional_bookings}%
                  </span>{" "}
                  /{" "}
                  <span title={"Managed"}>
                    {reportData[1].percentage_of_managed_provisional_bookings}%
                  </span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <span title={"Direct"}>
                    {reportData[2].percentage_of_direct_provisional_bookings}%
                  </span>{" "}
                  /{" "}
                  <span title={"Managed"}>
                    {reportData[2].percentage_of_managed_provisional_bookings}%
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  title={
                    columnTitleHelper + " (includes revising confirmation)"
                  }
                >
                  <span className={"my-1 inline-block"}>No. of Enquiries</span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>
                    {reportData[0].number_of_provisional_bookings}
                  </strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>
                    {reportData[1].number_of_provisional_bookings}
                  </strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>
                    {reportData[2].number_of_provisional_bookings}
                  </strong>
                </td>
              </tr>

              <tr className={"bg-off-white"}>
                <td>
                  <strong>Denied</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <span title={"Direct"}>
                    {reportData[0].percentage_of_direct_denied_bookings}%
                  </span>{" "}
                  /{" "}
                  <span title={"Managed"}>
                    {reportData[0].percentage_of_managed_denied_bookings}%
                  </span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <span title={"Direct"}>
                    {reportData[1].percentage_of_direct_denied_bookings}%
                  </span>{" "}
                  /{" "}
                  <span title={"Managed"}>
                    {reportData[1].percentage_of_managed_denied_bookings}%
                  </span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <span title={"Direct"}>
                    {reportData[2].percentage_of_direct_denied_bookings}%
                  </span>{" "}
                  /{" "}
                  <span title={"Managed"}>
                    {reportData[2].percentage_of_managed_denied_bookings}%
                  </span>
                </td>
              </tr>

              <tr>
                <td title={columnTitleHelper}>
                  <span className={"my-1 inline-block"}>No. of Enquiries</span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[0].number_of_denied_bookings}</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[1].number_of_denied_bookings}</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[2].number_of_denied_bookings}</strong>
                </td>
              </tr>

              <tr>
                <td title={columnTitleHelper}>
                  <span className={"my-1 inline-block"}>
                    Value of Enquiries
                  </span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>
                    {formatValue(reportData[0].value_of_denied_bookings)}
                  </strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>
                    {formatValue(reportData[1].value_of_denied_bookings)}
                  </strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>
                    {formatValue(reportData[2].value_of_denied_bookings)}
                  </strong>
                </td>
              </tr>

              <tr className={"bg-off-white"}>
                <td colSpan={4}>
                  <strong>Summary</strong>
                </td>
              </tr>
              <tr>
                <td title={columnTitleHelper}>
                  <span className={"my-1 inline-block"}>Cost Savings</span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[0].total_percentage_savings}%</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[1].total_percentage_savings}%</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[2].total_percentage_savings}%</strong>
                </td>
              </tr>
              <tr>
                <td title={columnTitleHelper}>
                  <span className={"my-1 inline-block"}>Conversion Rate</span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[0].conversion_rate}%</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[1].conversion_rate}%</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[2].conversion_rate}%</strong>
                </td>
              </tr>
              {!isVenueUser ?
              <tr>
                <td title={columnTitleHelper}>
                  <span className={"my-1 inline-block"}>Commission earned</span>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[0].commission_earned}%</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[1].commission_earned}%</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{reportData[2].commission_earned}%</strong>
                </td>
              </tr> : null }

            </>
          )}
        </tbody>
      </table>
    </Fragment>
  );
};

const mapStateToProps = (state, props) => {
  return {
    isVenueUser: isVenue(state) || isGroupUser(state) || isGroupAdmin(state) || isVenueAdmin(state)
  };
};

VenueSnapshotReportTableDash = connect(mapStateToProps, {})(VenueSnapshotReportTableDash);
export default VenueSnapshotReportTableDash;
